<!-- Beginning of the right draw -->
<template v-slot:default="{ on, attrs }">
  <v-card class="mx-auto" color="grey lighten-2">
    <v-navigation-drawer 
      app 
      right 
      color="white" 
      v-model="drawer" 
      permanent
      :temporary="isMobile"
      :style="isMobile ? { zIndex: 1200 } : {}"
      :permanent="!isMobile"
    >
      <!--
        bottom
        temporary 
        absolute
        :mini-variant.sync="mini"
        <v-icon @click.stop="mini = !mini" class="pr-2">mdi-chevron-right</v-icon>
        -->
      <v-list-item class="pt-2 px-2">
        <!--Beginning of profile sheet-->
        <v-bottom-sheet width="1200px">
          <template v-slot:activator="{ props, on }">
            <v-btn color="transparent" elevation="0" class="pl-3" v-bind="props" v-on="on" v-model="sheet">
              <v-list-item-group class="text-left">
                <v-list-item-title>{{ user.first_name }} {{ user.last_name }}</v-list-item-title>
                <v-list-item-subtitle class="text-caption">{{ user.email }}</v-list-item-subtitle>
              </v-list-item-group>
            </v-btn>
          </template>
          <!------------------------------>
          <profilePage />
          <!--End of sheet profile-->
        </v-bottom-sheet>
        <!--end of profile sheet-->
        <!---->
      </v-list-item>
      <v-dialog 
        v-model="showIdeaForm" 
        persistent
        width="1024" 
        :fullscreen="$vuetify.breakpoint.smAndDown">
        <template v-slot:activator="{ on, props }">
          <v-list-item-title class="pl-5 font-weight-normal" color="blue darken-2">
            <v-btn v-bind="props" v-on="on" color="blue darken-2" icon="true"
              @click="toggleJobForm"><v-icon size="30">mdi-briefcase-plus</v-icon>
            </v-btn>
            Upload Business Ideas
          </v-list-item-title>
        </template>
        <ideaForm
          @close-dialog="showIdeaForm = false"
          @handle-toggle-form="toggleJobForm" 
          @fetch-business-ideas="getBusinessIdeas" />
      </v-dialog>
      <!-- Dropdown menu begins here -->
      <!-- List item begins here -->
      <v-list-item v-for="item in items" :key="item.id" link color="white">
        <v-row dense>
          <v-col>
            <v-list dense>
              <v-card>
                <v-list-item class="pa-0 text-caption">
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <v-img :src="item.company_logo" max-width="25" contain alt="company logo"></v-img>
                        <v-list-item-title class="pl-1">
                          {{ item.title }} 
                        </v-list-item-title>
                      </v-expansion-panel-header>
                      <v-progress-linear buffer-value="90" value="60" stream color="blue"></v-progress-linear>
                      <v-expansion-panel-content>
                        {{ truncateDescription(item.description, 100) }}
                        <v-card-actions>
                          <v-btn v-bind="attrs" v-model="sheet" v-on="on" color="blue" @click="toggleProfilePage"
                            x-small text right>
                            <a :href="''+ item.website_link" target="_blank">View More</a>
                          </v-btn>
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-list-item>
              </v-card>
            </v-list>
          </v-col>
        </v-row>
      </v-list-item>
      <!--Ending of second right draw-->
      <!-- Drop down menu's end here -->
      <div class="bottom-div">
      <v-list-item-title class="pb-0 text-button">
        Online
        <v-icon color="green" dark>mdi-broadcast</v-icon>
      </v-list-item-title>
      <v-card class="mx-auto pa-3" outlined color="transparent">
        <v-row>
          <v-col
            v-for="(user, index) in users"
            :key="index"
            cols="3"
            class="d-flex flex-column align-center pa-2"
          >
            <div
              :class="[
                'rounded-circle',
                'd-flex',
                'align-center',
                'justify-center',
                'pa-1',
                user.online ? 'online-border' : 'offline-border'
              ]"
              style="width: 45px; height: 45px;"
            >
            <!-- Avatar -->
              <v-avatar size="35">
                <v-img :src="user.image" :alt="user.name"></v-img>
              </v-avatar>
            </div>
            <!-- Username -->
            <div class="text-center text-truncate" style="max-width: 60px; font-size: 12px;">
              {{ user.name }}
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-col no-gutters cols="12" class="pt-0">
        <v-btn class="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default primary" @click="logOut">
          Log out
        </v-btn>
      </v-col>
        <v-col color="white darken-4" cols="12" class="pt-0 pb-0">
          <v-text-field v-model="message4" label="Search..." outlined clearable></v-text-field>
        </v-col>
      </div>
      <!--
        <v-fade-transition>
        <v-overlay
          v-if="hover"
          absolute
          color="#01579B"
        >
          <v-btn>Coming soon...</v-btn>
        </v-overlay>
      </v-fade-transition>
      -->
    </v-navigation-drawer>
  </v-card>
</template>
<script>
import axios from 'axios'
import { apiUrl } from '../config'
import { mapGetters, mapState } from 'vuex'
import ideaForm from './ideaForm'
import profilePage from './profilePage'
export default {
  data: () => ({
    showProfilePage: false,
    showIdeaForm: false,
    //drawer: false,
    dialog: "",
    sheet: "",
    message4: "",
    API_URL: apiUrl,
    profileData: [""],
    profile_image: '',
    items: [

    ],
    mini: true,
    users: [
      { name: 'Alex', image: 'https://randomuser.me/api/portraits/men/10.jpg' },
      { name: 'Sam', image: 'https://randomuser.me/api/portraits/women/11.jpg' },
      { name: 'Taylor', image: 'https://randomuser.me/api/portraits/men/12.jpg' },
      { name: 'Jordan', image: 'https://randomuser.me/api/portraits/women/13.jpg' },
      { name: 'Chris', image: 'https://randomuser.me/api/portraits/men/14.jpg' },
      { name: 'Pat', image: 'https://randomuser.me/api/portraits/women/15.jpg' },
      { name: 'Jamie', image: 'https://randomuser.me/api/portraits/men/16.jpg' },
      { name: 'Charlie', image: 'https://randomuser.me/api/portraits/women/17.jpg' },
      { name: 'Nick', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
      { name: 'John', image: 'https://randomuser.me/api/portraits/women/5.jpg' },
      { name: 'James', image: 'https://randomuser.me/api/portraits/men/8.jpg' },
      { name: 'Mane', image: 'https://randomuser.me/api/portraits/women/20.jpg' },
      
    ]
  }),
  props: {
    value: { type: Boolean, default: false }, // <- parent will drive this
    isMobile: Boolean
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters({ user: "auth/user" }),
    drawer: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val) // keep parent in sync
      }
    }
  },
  components: {
    profilePage,
    ideaForm
  },
  methods: {
    truncateDescription(description, limit) {
      if (description.length <= limit) {
        return description;
      }
      return description.substring(0, limit) + '...';
    },
    async getBusinessIdeas() {
      console.log('fetch get business ideas function triggered')
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)

        const response = await axios.get(`${this.API_URL}business-ideas/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        console.log("business ideas ====>", response.data);
        this.items = response.data;


      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    async getProfileData() {
      try {
        // fetch profile
        let user = localStorage.getItem('user');
        user = JSON.parse(user);

        const authToken = 'Bearer ' + user['access'];

        console.log(authToken)

        const response = await axios.get(`${this.API_URL}users/current-user/`, {
          headers: {
            'Authorization': authToken,
          },
        })
        // set the data returned as profile
        this.profileData = response.data;
        this.profile_image = this.profileData?.profile.profile_image;
        console.log(this.profileData);

      } catch (error) {
        // log the error
        console.log(error);
      }
    },
    toggleJobForm() { 
      this.dialog = !this.dialog;
      console.log(this.dialog)
      console.log('emmitted')
    },
    toggleProfilePage() {
      this.showProfilePage = !this.showProfilePage;
    },
    reserve() { },
    logOut() {
      this.$store.dispatch("auth/logout").then(res => {
        this.$success(res)
        this.$router.push("/")
      })
    },
  },
  created() {
    this.getProfileData();
    this.getBusinessIdeas();
  },
}
</script>
<style>
  .online-border {
    border: 3px solid #4caf50; /* green border for online */
  }

  .offline-border {
    border: 3px solid green; /* grey border for offline */
  }
  .bottom-div { 
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #FFF;
    padding: 16px;
  }
</style>